<template>
  <div class="row">
    <div class="col">
      <label for="serial-numbers">Serial Numbers</label>
      <div>
        <div v-if="serialNumbers.length > 0">
          <div v-for="(item, index) in serialNumbers" :key="index">
            <div class="row-wrapper p-2 row">
              <div class="col-12 col-sm-3">
                <el-input
                  v-model="item.name"
                  type="text"
                  placeholder="Name"
                  class="mb-2"
                ></el-input>
              </div>
              <div class="col-12 col-sm-3">
                <el-checkbox
                  v-model="item.available"
                  true-value="1"
                  false-value="0"
                  >Available?</el-checkbox
                >
              </div>
              <div
                class="delete-row"
                @click="
                  () => {
                    this.serialNumbers.splice(index, 1);
                    if (item.id > 0) {
                      this.delete_serial_numbers.push(item.id);
                    }
                  }
                "
              >
                <svg
                  class="svg-inline--fa fa-trash-alt fa-w-14"
                  data-v-b4ae8fbc=""
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="trash-alt"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  data-fa-i2svg=""
                >
                  <path
                    fill="currentColor"
                    d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
        </div>
        <el-button
          class="button_style_1 mt-2"
          @click="
            () => {
              this.serialNumbers.push({
                name: '',
                available: true,
              });
            }
          "
        >
          Add New Row
        </el-button>
        <el-button class="button_style_1 mt-2" @click="serialNumbersHandler">
          Save
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { ElNotification } from "element-plus";

export default {
  name: "SerialNumbers",
  props: ["postId"],
  data() {
    return {
      serialNumbers: [],
      artwork_id: this.postId,
      new_serial_numbers: [],
      update_serial_numbers: [],
      delete_serial_numbers: [],
    };
  },
  methods: {
    serialNumbersHandler() {
      this.update_serial_numbers = [];
      this.new_serial_numbers = [];
      this.serialNumbers.map((snumber) => {
        if (
          snumber?.id &&
          !this.delete_serial_numbers.find((e) => e.id === snumber.id)
        ) {
          this.update_serial_numbers.push(snumber);
        } else {
          this.new_serial_numbers.push(snumber);
        }
      });
      this.sendToServer();
    },
    sendToServer() {
      const loader = this.$loading.show();
      axios
        .post(
          `${process.env.VUE_APP_SHARED_API}api/serial-number`,
          {
            artwork_id: this.artwork_id,
            new_serial_numbers: this.new_serial_numbers,
            update_serial_numbers: this.update_serial_numbers,
            delete_serial_numbers: this.delete_serial_numbers,
          },
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("bearerToken"),
            },
          }
        )
        .then((res) => {
          loader.hide();
          if (res.data[0]) {
            ElNotification({
              title: "Success!",
              message: "Serial Numbers uploaded successfully!",
              type: "success",
            });
            this.update_serial_numbers = [];
            this.new_serial_numbers = [];
            this.delete_serial_numbers = [];
            this.serialNumbers = [];
            let modifyArr = [];
            res.data.map((number) => {
              modifyArr.push({
                ...number,
                available: number.available == 0 ? false : true,
              });
            });
            this.serialNumbers = [...modifyArr];
          }
        })
        .catch((e) => {
          loader.hide();
          ElNotification({
            title: "Oops!",
            message: "Something went wrong, please try later",
            type: "warning",
          });
        });
    },
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === "SERIAL_NUMBERS") {
        this.serialNumbers = [
          ...state.customFields.serialNumbers,
          ...this.new_serial_numbers,
          ...this.update_serial_numbers,
        ];
      }
    });
  },
  beforeUnmount() {
    this.unsubscribe();
  },
};
</script>

<style lang="scss" scoped>
.delete-row > svg {
  color: white;
  fill: white;
}
.required-field {
  color: red;
  font-weight: bold;
}
.row-wrapper {
  position: relative;
}
.delete-row {
  position: absolute;
  top: -5px;
  left: -20px;
  height: 20px;
  width: 20px;
  cursor: pointer;
  display: flex;
  align-content: center;
  justify-content: center;
  background-color: red;
  border-radius: 50%;
  align-items: center;
}
.acf-fields {
  min-height: 150px;
  margin-top: 30px;
  // margin-bottom: 30px;
}
</style>

